import { useFormikContext } from 'formik';

export const useDotsNotCommas = () => {
  const { setFieldValue } = useFormikContext();

  const replaceCommasWithDots = ({ inputName, inputValue }) => {
    setFieldValue(inputName, inputValue.replace(/,/g, '.'));
  };

  return {
    replaceCommasWithDots,
  };
};
